import React from 'react';
import { FaBusinessTime, FaLaptopCode } from 'react-icons/fa';
import '../styles/SkillsSection.css';

const SkillsSection = () => {
  // Skills data structure including the "Skills" main category and detailed skills for each subcategory
  const skillsData = {
    mainCategory: "Skills",
    categories: [
      {
        title: "MGT SKILLS",
        icon: <FaBusinessTime />,
        subcategories: [
          {
            title: "Strategic Leadership and Mgt",
            skills: ["Leadership", "IT/Business Strategy", "Critical Thinking", "Digital Transformation", "Program Management", "Budgeting", "Resource Management", "Cost Allocation", "Team building", "Communication", "Contract Management", "Root Cause Analysis"],
          },
          {
            title: "Operations and Process",
            skills: ["Electric Vehicle Production", "Manufacturing & IT Operations", "Process Improvement", "Incident Management"],
          },
          {
            title: "Program Management",
            skills: ["Agile Methodologies (SaFE)", "Program Management", "Strategic Planning", "Demand Intake"],
          },
        ],
      },
      {
        title: "TECHNICAL SKILLS",
        icon: <FaLaptopCode />,
        subcategories: [
          {
            title: "Enterprise Architecture",
            skills: ["Cloud Computing (AWS)", "Enterprise Architecture", "Network Architecture", "Software Architecture", "Integration", "IT Security", "Governance and Compliance", "LeanIX/Troux", "Roadmapping", "TOGAF"],
          },
          {
            title: "Software Engineering",
            skills: ["DevOps", "Dynatrace/Grafana", "Prometheus", "Ansible", "Kubernetes", "Docker", "Log Aggregation", "Relational Database"],
          },
          {
            title: "Manufacturing",
            skills: ["MES", "PLM", "ERP", "Quality", "EV Process", "SCADA", "Ignition", "HMI", "Printers", "IT/OT Design", "Edge Computing"],
          },
          {
            title: "Insurance",
            skills: ["Guidewire", "Document Repository", "Data Analytics"],
          },
        ],
      },
    ],
  };

  return (
    <div className="skills-section">
      <h2>{skillsData.mainCategory}</h2>
      {skillsData.categories.map((category, idx) => (
        <div key={idx} className="skills-category">
          <h3>{category.title} <span className="category-icon">{category.icon}</span></h3>
          {category.subcategories.map((sub, subIdx) => (
            <div key={subIdx} className="skills-subcategory">
              <h4>{sub.title}</h4>
              <p>{sub.skills.join(", ")}</p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SkillsSection;
